import { SIM } from '../config/tuning';

/**
 * The simulation clock.
 *
 * Nothing inside the simulation may read the wall clock — every tick advances by exactly
 * `fixedDtS`, so simulated time is a pure function of the tick count (SPEC §4.3). Wall-clock
 * time lives in Loop and never crosses into a fixedUpdate.
 */
export class Time {
  /** Fixed simulation timestep, seconds. */
  readonly fixedDtS: number;

  /** Ticks simulated since reset. */
  tick = 0;

  /** Simulated time since reset, seconds. Derived from the tick count, never accumulated. */
  simTimeS = 0;

  /** Render interpolation factor in [0, 1): how far the render sits past the last tick. */
  alpha = 0;

  /** Wall-clock multiplier applied before accumulation. 1 = real time, 0.1 = slow motion. */
  timeScale = 1;

  /** When true the accumulator does not advance; single-step still works. */
  paused = false;

  constructor(fixedDtS: number = SIM.FIXED_DT) {
    this.fixedDtS = fixedDtS;
  }

  /** Advance exactly one tick. Called only by Loop. */
  advanceTick(): void {
    this.tick += 1;
    this.simTimeS = this.tick * this.fixedDtS;
  }

  /** Reset the clock to t = 0, preserving timeScale and paused state. */
  reset(): void {
    this.tick = 0;
    this.simTimeS = 0;
    this.alpha = 0;
  }
}
